// extracted by mini-css-extract-plugin
export default {"circle_fly":"animation_circle_fly__T8wwB","fly":"animation_fly__kjcZl"};